<script setup lang="ts">
import HamburgerMenu from './HamburgerMenu.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

const menuOpen = ref(false)
const router = useRouter()

function onToggle(open: boolean) {
  menuOpen.value = open
}

// Close menu when navigation occurs
function handleNavigation(to: string) {
  menuOpen.value = false
  router.push(to)
}
</script>

<template>
  <header class="header-bar">
    <div class="header-left">
      <HamburgerMenu :open="menuOpen" @toggle="onToggle">
        <template #menu>
          <a class="menu-link" @click="handleNavigation('/')">Inicio</a>
          <a class="menu-link" @click="handleNavigation('/servicios')">Servicios</a>
          <a class="menu-link" @click="handleNavigation('/sala-equipos')">Sala de Equipos</a>
          <a class="menu-link" @click="handleNavigation('/senalizacion')">Señalamientos de seguridad industrial</a>
          <a class="menu-link" @click="handleNavigation('/contacto')">Contáctanos</a>
        </template>
      </HamburgerMenu>
    </div>
    <div class="header-center">
      <img
        src="@/assets/images/fs-brand-1.png"
        alt="FireStop MX Logotipo"
        class="brand-logo"
        draggable="false"
      />
    </div>
    <div class="header-spacer"></div>
  </header>
</template>

<style scoped>
.header-bar {
  background: var(--bg-primary);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1.5rem;
  min-height: 80px;
  position: relative;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

.header-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}

.brand-logo {
  height: 160px;
  max-width: 300px;
  object-fit: contain;
  pointer-events: auto;
  margin-top: 2rem;
}

.header-spacer {
  width: 40px;
  opacity: 0;
  flex-shrink: 0;
}

/* DESKTOP */
@media (min-width: 768px) {
  .header-bar {
    padding: 0.75rem 2rem;
    min-height: 90px;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .header-left {
    gap: 0.5rem;
  }

  .brand-logo {
    margin-top: 1rem;
    height: 120px;
    max-width: 180px;
  }
}
</style>
